<template>
  <div id="app">
    <WxShare :shareTitle="title" :shareDesc="desc" :shareImg="thumbImg" :shareLink="link" />
	  <Main></Main>
    <!-- <Loading :isShow="showOrNot" /> -->
    <!-- <MusicPlay :isShow="showOrNot" /> -->
     <!-- <router-link to="./components/musicPlay/MusicPlay" :isShow="showOrNot"></router-link> -->
	
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/> -->
  </div>
</template>

<script>
import WxShare from './components/wxShare/wxShare';
import axios from 'axios';
import Loading from './views/loading/loading';
import Main from './views/Main';
import Qs from "qs";
import * as browser from  'judgebrowser'
import getcookie from "./utils/getCookie"

let ss = Qs.parse(location.href.split("?")[1])
//console.log(ss.token_code)
//localStorage.setItem('token',ss.token_code)

if(ss.token_code!=undefined){
    console.log("sss:",ss.token_code)
    localStorage.setItem('token',ss.token_code)
}else{
    let token ="";
    if(browser.weixin){
      token = getcookie("wx_token_code");
    }else if(browser.weibo){
      token = getcookie("wb_token_code");
    }else{
      token = getcookie("wb_token_code");
    }
    localStorage.setItem('token',token)
}



export default {
  name: 'App',
  components: {
	Main,
    Loading,
    // MusicPlay,
    WxShare,
  },
  data() {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPageShow: false,
      },
      desiginwidth: 1920,

      title: '网聚民声 鹭力同心',
      desc: '厦门市政协无党派人士界别网上委员联系点邀您建言献策',
      thumbImg: 'http://n.sinaimg.cn/fj/tongxin/img/wxshare.jpg',
      link: location.origin + location.pathname,
      projectInfor: {
        // username:"XXXX",
        // pv:0,
        // allamount:0,
      },
    };
  },
  mounted() {
    const _this = this;
	
    function windowResize() {
      const { devicePixelRatio } = window;
      const documentWidth = document.documentElement.clientWidth;
      let rem = documentWidth / _this.desiginwidth * 100;// * devicePixelRatio;
      document.documentElement.style.fontSize = `${rem}px`;
      if (rem >= 135) rem=135;
      document.documentElement.style.fontSize=rem +"px";
      //处理特殊机型
      if(window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize) {
        var size = window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.split('p')[0];
        console.log("size=======" + size);
        if(size*1.2 < rem ) {
          document.documentElement.style.fontSize = 1.25 * rem + 'px';
        }
      };
    }
    windowResize();
	window.onresize = windowResize;
	
	// 微信授权
    axios.post('https://www.appmn.cn/project2022/huijululi/browse.php', Qs.stringify({token_code:localStorage.getItem('token')}), {
      withCredentials: true,
    }).then((res) => {
      if (res.data.err == 3001) {
		  alert("请使用微博授权登录！");
        const callbackurl = encodeURIComponent(window.location.href);
        window.location.replace("https://api.weibo.com/oauth2/authorize?client_id=585049065&redirect_uri="+encodeURIComponent('https://www.appmn.cn/public/weibo/oauth2_wlsx_index.php?redirect_url='+callbackurl)+"&response_type=code&state=123&display=123");
      } else if (res.data.err == 2001) {
        const callbackurl = encodeURIComponent(window.location.href);
       window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4b3447b9d54801f4&redirect_uri="+encodeURIComponent('https://www.appmn.cn/public/weixin/oauth2_xmtch_index.php?redirect_url='+callbackurl)+"&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect");
      } else if (res.data.err == 0) {
        this.projectInfor = { ...res.data.data };
      }
    }).catch((err) => {
      console.log(err);
    }); 
  },
};
</script>

<style lang="scss">
#app{
  position: relative;
	width: 100%;
	height: 100%;
}
</style>
